import RangeDatePicker from '@/components/datepicker/multiRangeDatepicker/MultiDatepicker'
import React, { FC } from 'react'
import styles from './CalendarDesktop.module.scss'
import Box from '@/components/UI/box/Box'
interface CalenderDesktopProps {
  open: boolean
  calendarRef: any
  calendar: any
  checkin: number | null
  checkout: number | null
  isFull?: boolean
  withTooltip?: boolean
  isMidterm?: boolean
  handleChange: any
}
const CalendarDesktop: FC<CalenderDesktopProps> = ({
  open,
  checkin,
  checkout,
  calendarRef,
  handleChange,
  calendar,
  isFull = false,
  withTooltip,
  isMidterm,
}) => {
  return (
    <>
      {open && (
        <Box className={styles['calender-desktop']}>
          <RangeDatePicker
            calendar={calendar}
            dateType={'JALALI'}
            dateRef={calendarRef}
            dates={{ checkin, checkout }}
            onChange={handleChange}
            isFull={isFull}
            withTooltip={withTooltip}
            nextRangeMonths={isMidterm ? 365 : 90}
          />
        </Box>
      )}
    </>
  )
}

export default CalendarDesktop
